import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import { Grid, Box } from "@mui/material";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { GHG_EMISSIONS_MANAGEMENT_FORM } from "data/forms/griFormSchema";
import {
  emissionsTracking,
  emissionsMethodologyChecklist,
  realTimeEmissionCalculation,
  esSurveyMonitoringToolType,
  esSurveyScopeFormatSpecs,
  esSurveyScopeDevelopFormat,
  esSurveyScopeCustomFinalizeTool,
  esSurveyScopeDownloadTool,
  esSurveyScopeComplianceTracking,
  esSurveyScopeDownloadTrackingStatus,
} from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import { EMISSION_METHODOLOGY_CHECKLIST } from "data/standards/griStandards";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";

const SurveyMonitorTrackTool = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  // Force re-render of components when step changes
  const [forceUpdate, setForceUpdate] = useState(0);
const steps = [
  "Download Tracking Status",
  "Define Scope & Format Specifications",
  "Develop Format / Checklist Content",
  "Customize & Finalize Tool",
  "Download or Deploy the Tool",
  "Compliance Tracking (Optional)",
  "E&S Survey, Monitoring and Tracking Tools",
  "Upload Evidence and Review Reports",
  "Download Post Review Gap Form",
  "Upload Post Review Gap Form",
  "Download Final Post Review Reports",
];


  useEffect(() => {
      if (activeStep === 7 && prevStep === 6) {
          setShowReviewPopup(true);
      }
      setForceUpdate(prev => prev + 1);
  }, [activeStep, prevStep]);

  // const handleNext = () => {
  //   if (activeStep < 6) {
  //     setActiveStep((prev) => prev + 1);
  //   } else {
  //     console.log("Reached end of stepper");
  //   }
  // };
  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(8);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DownloadReport
            key="es-tool-types-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyMonitoringToolType}
            ReportDownloadButtonShow = {false}
            title="Download Tracking Status"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
          />
        );
      case 1:
        return (
          <DownloadReport
            key="scope-format-specification-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyScopeFormatSpecs}
            title="Define Scope & Format Specifications"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );
      case 2:
        return (
          <DownloadReport
            key="development-format-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyScopeDevelopFormat}
            title="Develop Format / Checklist Content "
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );
      case 3:
        return (
          <DownloadReport
            key="customized-finalized-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyScopeCustomFinalizeTool}
            title="Customize & Finalize Tool"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );
      case 4:
        return (
          <DownloadReport
            key="download-customized-finalized-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyScopeDownloadTool}
            title="Download or Deploy the Tool"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
          />
        );

      case 5:
        return (
          <DownloadReport
            key="download-customized-finalized-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyScopeComplianceTracking}
            title="Compliance Tracking (Optional)"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );

      case 6:
        return (
          <DownloadReport
            key="download-customized-finalized-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esSurveyScopeDownloadTrackingStatus}
            title="Download Tracking Status"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            showReportCountdownButton={true}
          />
        );
      case 7:
        return (
          <UploadEvidenceReviewReports
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 8:
        return (
          <DownloadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 9:
        return (
          <UploadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 10:
        return (
          <DownloadPostReviewReports
            onPrevious={handleBack}
            showReportCountdownButton={true}
            standardName="Universal Risk Assessment"
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader
              title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
              subtitle="AI-Powered greenhouse gas emissions tracking, calculation, and regulatory reporting"
            />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg3_5"
                title="E&S Survey, Monitoring & Tracking Tools"
                activeStep={activeStep}
                onBack={handleBack}
                steps={steps}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box key={`step-content-${activeStep}-${forceUpdate}`}>
            {getStepContent(activeStep)}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                  transition: "background-color 0.3s ease",
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default SurveyMonitorTrackTool;
